import React, { createContext, useState, useContext, useMemo, useCallback } from 'react';

const LanguageContext = createContext();

const translations = {
  it: {
    adminTitle: 'Accesso amministratore',
    loginButton: 'Accedi',
    forgotPassword: 'Hai dimenticato la password?',
    membersListTitle: 'Elenco membri',
    table_member: 'Membro palestra',
    table_id: 'ID Membro',
    table_subscription: 'Tipo di abbonamento',
    table_status: 'Stato abbonamento',
    deleteConfirm: 'Sei sicuro di voler eliminare questo membro?',
    createTitle: 'Aggiungi nuovo membro',
    editTitle: 'Modifica membro',
    createButton: 'Crea membro',
    saveButton: 'Salva modifiche',
    namePlaceholder: 'Nome',
    emailPlaceholder: 'Email',
    phonePlaceholder: 'Telefono',
    startPlaceholder: 'DD/MM/YY',
    endPlaceholder: 'DD/MM/YY',
    languageLabel: 'Lingua',
    subscription_bronze: 'Bronze',
    subscription_silver: 'Silver',
    subscription_gold: 'Gold',
    subscription_platinum: 'Platinum',
    status_attivo: 'Attivo',
    status_inattivo: 'Inattivo',
    status_scaduto: 'Scaduto',
    searchPlaceholder: 'Cerca membro per nome...',
    searchNoResults: 'Nessun membro trovato.',
  },
  en: {
    adminTitle: 'Administrator Login',
    loginButton: 'Sign in',
    forgotPassword: 'Forgot password?',
    membersListTitle: 'Members List',
    table_member: 'Member',
    table_id: 'Member ID',
    table_subscription: 'Subscription Type',
    table_status: 'Subscription Status',
    deleteConfirm: 'Are you sure you want to delete this member?',
    createTitle: 'Add new member',
    editTitle: 'Edit member',
    createButton: 'Create member',
    saveButton: 'Save changes',
    namePlaceholder: 'Name',
    emailPlaceholder: 'Email',
    phonePlaceholder: 'Phone',
    startPlaceholder: 'DD/MM/YY',
    endPlaceholder: 'DD/MM/YY',
    languageLabel: 'Language',
    subscription_bronze: 'Bronze',
    subscription_silver: 'Silver',
    subscription_gold: 'Gold',
    subscription_platinum: 'Platinum',
    status_attivo: 'Active',
    status_inattivo: 'Inactive',
    status_scaduto: 'Expired',
    searchPlaceholder: 'Search member by name...',
    searchNoResults: 'No members found.',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('it');

  const t = useCallback((key) => translations[language]?.[key] ?? key, [language]);

  const value = useMemo(() => ({ language, setLanguage, t }), [language, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export default LanguageContext;
